import { useInfiniteQuery } from '@tanstack/react-query'
import { giftService } from '../../../services/gifts/gifts'
import { setGraphClientAuthToken } from '../../../services/graph-client'
import type { GetList } from '../../../services/gifts/gifts/types'

export const GIFTS_QUERY_KEY = 'getGifts'

export const useGetGifts = (
  params?: GetList.Input,
  options?: { enabled?: boolean; token?: string | null },
) => {
  const {
    data,
    isFetchingNextPage,
    isLoading,
    hasNextPage,
    refetch,
    fetchNextPage,
  } = useInfiniteQuery({
    queryKey: [GIFTS_QUERY_KEY, params],
    staleTime: Infinity,
    retry: 1,
    initialPageParam: 0,
    enabled: options?.enabled ?? true,
    queryFn: ({ pageParam: skip }) => {
      setGraphClientAuthToken(options?.token)
      return giftService.getList({ take: 20, skip, ...params })
    },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPage && !lastPage?.data?.length) {
        return null
      }

      if (lastPage?.error) {
        return null
      }

      return lastPageParam + 1
    },
  })

  return {
    gifts: data?.pages?.flatMap((page) => page?.data),
    totalPages: data?.pages?.[0]?.totalPages ?? 0,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    refetch,
    nextPage: fetchNextPage,
  }
}
